// eCards.js

import { getStorage, getFirestore, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from "../../firebase";
import React, { useState, useEffect, useRef } from "react";
import { View, Text, TextInput, ScrollView, Pressable, Modal, StyleSheet, Platform, Image, Animated } from "react-native";
import { Ionicons } from '@expo/vector-icons';


const eCards = [
	{ cardName: "Card1", front: require("../../assets/eCards/card1F.png"), back: require("../../assets/eCards/card1B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard1F.png?alt=media&token=e89f1e1a-1b5c-47a7-9f1d-ae63191e3825" },
	{ cardName: "Card2", front: require("../../assets/eCards/card2F.png"), back: require("../../assets/eCards/card2B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard2F.png?alt=media&token=90f855c0-5a09-46e6-bcaa-92da67ae5cc9" },
	{ cardName: "Card3", front: require("../../assets/eCards/card3F.png"), back: require("../../assets/eCards/card3B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard3F.png?alt=media&token=5e75508d-5b9e-43d6-a051-763404819650" },
	{ cardName: "Card4", front: require("../../assets/eCards/card4F.png"), back: require("../../assets/eCards/card4B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard4F.png?alt=media&token=87489d7e-8288-407b-946e-e6bf27781f5d" },
	{ cardName: "Card5", front: require("../../assets/eCards/card5F.png"), back: require("../../assets/eCards/card5B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard5F.png?alt=media&token=81e5cba2-b04e-46c6-a93f-30ebdf0e8efc" },
	{ cardName: "Card6", front: require("../../assets/eCards/card6F.png"), back: require("../../assets/eCards/card6B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard6F.png?alt=media&token=2b6ac1fd-7d11-4bc2-966f-94e7dbb2fac7" },
	{ cardName: "Card7", front: require("../../assets/eCards/card7F.png"), back: require("../../assets/eCards/card7B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard7F.png?alt=media&token=676e0289-2a4c-40b4-80aa-9d3391312d9d" },
	{ cardName: "Card8", front: require("../../assets/eCards/card8F.png"), back: require("../../assets/eCards/card8B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard8F.png?alt=media&token=aeb5bd9d-f7a1-4362-91e8-8c5874462bba" },
	{ cardName: "Card9", front: require("../../assets/eCards/card9F.png"), back: require("../../assets/eCards/card9B.png"), frontStorageURL: "https://firebasestorage.googleapis.com/v0/b/my-tassel.appspot.com/o/eCards%2Fcard9F.png?alt=media&token=6b175a87-7a7e-4fd4-ac50-51f2c5f4b807" },
];

const STANDARD_CARD_WIDTH = 300;
const STANDARD_CARD_HEIGHT = 450;

const ECardSelectionModal = ({ isVisible, onSelect, onClose }) => {

	const [selectedCard, setSelectedCard] = useState(null);
	const [isCardSelected, setIsCardSelected] = useState(false);
	const [name, setName] = useState("");
	const [message, setMessage] = useState("");
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const canvasRef = useRef(null);
	const scrollViewRef = useRef(null);
	const toastOpacity = useRef(new Animated.Value(0)).current;

	// Reset state when modal closes
	useEffect(() => {
		if (!isVisible) {
			setSelectedCard(null);
			setIsCardSelected(false);
			setName("");
			setMessage("");
			setShowToast(false);
		}
	}, [isVisible]);

	// Function to scroll the ScrollView
	const scroll = (direction) => {
		if (scrollViewRef.current) {
			const cardWidth = STANDARD_CARD_WIDTH * 0.7 + 16; // card width + margin
			const scrollAmount = cardWidth * 2; // scroll 2 cards at a time
			
			scrollViewRef.current.scrollTo({
				x: direction === 'right' ? scrollAmount : -scrollAmount,
				animated: true,
			});
		}
	};

	// Toast notification functions
	const showToastNotification = (message) => {
		setToastMessage(message);
		setShowToast(true);
		Animated.sequence([
			Animated.timing(toastOpacity, {
				toValue: 1,
				duration: 300,
				useNativeDriver: true,
			}),
			Animated.delay(2500),
			Animated.timing(toastOpacity, {
				toValue: 0,
				duration: 300,
				useNativeDriver: true,
			})
		]).start(() => {
			setShowToast(false);
		});
	};

	// Function to calculate average brightness of cards
	const getAverageBrightness = (image) => {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		canvas.width = image.width;
		canvas.height = image.height;
		ctx.drawImage(image, 0, 0);
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		const data = imageData.data;
		let r, g, b, avg;
		let colorSum = 0;

		for (let x = 0, len = data.length; x < len; x += 4) {
			r = data[x];
			g = data[x + 1];
			b = data[x + 2];
			avg = Math.floor((r + g + b) / 3);
			colorSum += avg;
		}

		const brightness = Math.floor(colorSum / (canvas.width * canvas.height));
		return brightness;
	};

	const handleCardSelect = (card) => {
		setSelectedCard(card);
		setIsCardSelected(true); // Set to true when a card is selected
	};

	const clearSelectedCard = () => {
		setSelectedCard(null);
		setIsCardSelected(false); // Reset the state
	};

	useEffect(() => {
		const drawCanvas = async () => {
			if (selectedCard && Platform.OS === "web" && canvasRef.current) {
				const canvas = canvasRef.current;
				const ctx = canvas.getContext("2d");
				const image = document.createElement('img');
				image.src = selectedCard.back;

				await new Promise((resolve) => {
					image.onload = resolve;
				});

				canvas.width = STANDARD_CARD_WIDTH;
				canvas.height = STANDARD_CARD_HEIGHT;
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

				const brightness = getAverageBrightness(image);
				ctx.fillStyle = brightness > 128 ? "#4c956c" : "#fefde2";

				ctx.font = "22px Orpheus Pro";
				ctx.textAlign = "center";
				ctx.shadowColor = "rgba(0,0,0,0.25)"; // Add shadow color
				ctx.shadowOffsetX = 1; // Add shadow offset
				ctx.shadowOffsetY = 0; // Add shadow blur

				const drawText = (text, x, y, lineHeight, fitWidth) => {
					const words = text.split(" ");
					let line = "";
					for (let n = 0; n < words.length; n++) {
						const testLine = line + words[n] + " ";
						const metrics = ctx.measureText(testLine);
						const testWidth = metrics.width;
						if (testWidth > fitWidth && n > 0) {
							ctx.fillText(line, x, y);
							line = words[n] + " ";
							y += lineHeight;
						} else {
							line = testLine;
						}
					}
					ctx.fillText(line, x, y);
				};

				const maxLineWidth = canvas.width * 0.8;
				const lineHeight = 30;
				const displayMessage = message.slice(0, 75);
				const displayName = name.slice(0, 50);

				drawText(displayMessage, canvas.width / 2, canvas.height / 2 - lineHeight, lineHeight, maxLineWidth);
				if (displayName) {
					drawText(`- ${displayName}`, canvas.width / 2, canvas.height / 2 + 3 * lineHeight, lineHeight, maxLineWidth);
				}
			}
		};

		drawCanvas();
	}, [selectedCard, message, name]);

	const submitSelection = async () => {
		if (!selectedCard) {
			showToastNotification("Please select a card to continue");
			return;
		}

		if (!name.trim()) {
			showToastNotification("Please enter your name");
			return;
		}

		if (!message.trim()) {
			showToastNotification("Please enter a message");
			return;
		}

		if (Platform.OS === "web" && canvasRef.current) {

			const imageDataURL = canvasRef.current.toDataURL("image/png");
			// Convert data URL to blob
			const fetchResponse = await fetch(imageDataURL);
			const blob = await fetchResponse.blob();
			const uniqueFileName = `eCards/${Date.now()}-${selectedCard.cardName}.png`; // Adjust the naming convention as needed
			const storage = getStorage(app);
			const storageRef = ref(storage, uniqueFileName);

			try {
				await uploadBytes(storageRef, blob);
				const backImageUrl = await getDownloadURL(storageRef);
				let frontImageUrl = selectedCard.frontStorageURL;
				onSelect({ backImageUrl, frontImageUrl, name, message });
			} catch (error) {
				console.error("Error uploading eCard back image:", error);
				alert("Error uploading eCard, please try again later.");
			}
		}
	};

	return (
		<Modal visible={isVisible} animationType="slide" transparent={true}>
			<View style={styles.modalOverlay}>
				<View style={styles.modalView}>
					<View style={styles.headerContainer}>
						<Text style={styles.modalTitle}>Choose Your eCard</Text>
						<Pressable style={styles.closeIconButton} onPress={onClose}>
							<Ionicons name="close" size={24} color="#666" />
						</Pressable>
					</View>

					<ScrollView 
						style={styles.scrollableContent}
						contentContainerStyle={styles.scrollableContentContainer}
						showsVerticalScrollIndicator={true}
						keyboardShouldPersistTaps="handled"
						nestedScrollEnabled={true}
					>
						{!isCardSelected && (
							<Text style={styles.instructionText}>Select a card below to continue</Text>
						)}

						<View style={styles.cardSelectionContainer}>
							<Pressable style={[styles.arrowButton, styles.arrowLeft]} onPress={() => scroll('left')}>
								<Ionicons name="chevron-back" size={28} color="#4c956c" />
							</Pressable>
							<ScrollView
								ref={scrollViewRef}
								horizontal={true}
								style={[styles.cardScrollView, isCardSelected && styles.shrunkCardScrollView]}
								contentContainerStyle={styles.scrollViewContent}
								showsHorizontalScrollIndicator={false}
								nestedScrollEnabled={true}
								decelerationRate="fast"
							>
								{eCards.map((card, index) => (
									<Pressable 
										key={index} 
										onPress={() => handleCardSelect(card)}
										style={styles.cardContainer}
									>
										<Image 
											source={card.front} 
											style={selectedCard === card ? styles.selectedCard : styles.card} 
										/>
										{selectedCard === card && (
											<View style={styles.selectedOverlay}>
												<Ionicons name="checkmark-circle" size={32} color="#4c956c" />
											</View>
										)}
									</Pressable>
								))}
							</ScrollView>

							<Pressable style={[styles.arrowButton, styles.arrowRight]} onPress={() => scroll('right')}>
								<Ionicons name="chevron-forward" size={28} color="#4c956c" />
							</Pressable>
						</View>

						{isCardSelected && (
							<View style={styles.selectedCardPreview}>
								<View style={styles.previewHeader}>
									<Text style={styles.previewTitle}>Card Preview</Text>
									<Pressable style={styles.clearButton} onPress={clearSelectedCard}>
										<Ionicons name="close-circle" size={24} color="#ff6b6b" />
									</Pressable>
								</View>
								{Platform.OS === "web" && selectedCard && <canvas ref={canvasRef} style={styles.canvas}></canvas>}
							</View>
						)}

						<View style={styles.formContainer}>
							<View style={styles.inputContainer}>
								<Text style={styles.inputLabel}>Your Name *</Text>
								<TextInput 
									style={styles.input} 
									placeholder="Enter your name" 
									value={name} 
									onChangeText={setName} 
									maxLength={50}
									placeholderTextColor="#999" 
								/>
							</View>
							<View style={styles.inputContainer}>
								<Text style={styles.inputLabel}>Your Message *</Text>
								<TextInput 
									style={[styles.input, styles.messageInput]} 
									placeholder="Write a heartfelt message" 
									value={message} 
									multiline={true} 
									onChangeText={setMessage} 
									maxLength={75}
									placeholderTextColor="#999"
								/>
								<Text style={styles.characterCount}>{message.length}/75</Text>
							</View>
						</View>

						<View style={styles.buttonContainer}>
							<Pressable 
								style={[styles.primaryButton, (!selectedCard || !name.trim() || !message.trim()) && styles.disabledButton]} 
								onPress={submitSelection}
							>
								<Ionicons name="checkmark-circle-outline" size={20} color="white" style={styles.buttonIcon} />
								<Text style={styles.primaryButtonText}>Create eCard</Text>
							</Pressable>
						</View>
					</ScrollView>

					{showToast && (
						<Animated.View style={[styles.toast, { opacity: toastOpacity }]}>
							<Ionicons name="information-circle" size={20} color="white" style={styles.toastIcon} />
							<Text style={styles.toastText}>{toastMessage}</Text>
						</Animated.View>
					)}
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	modalOverlay: {
		flex: 1,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		justifyContent: 'flex-start',
		alignItems: 'center',
		paddingTop: 20,
	},
	modalView: {
		width: '95%',
		maxWidth: 800,
		height: '90%',
		backgroundColor: '#fefde2',
		borderRadius: 24,
		padding: 0,
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 10 },
		shadowOpacity: 0.3,
		shadowRadius: 20,
		elevation: 10,
	},
	headerContainer: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: 24,
		paddingBottom: 16,
		borderBottomWidth: 1,
		borderBottomColor: '#e6d690',
		backgroundColor: '#fefde2',
		borderTopLeftRadius: 24,
		borderTopRightRadius: 24,
	},
	modalTitle: {
		fontSize: 24,
		fontWeight: '700',
		color: '#2d3748',
		fontFamily: Platform.OS === 'ios' ? 'System' : 'Roboto',
	},
	closeIconButton: {
		padding: 8,
		borderRadius: 20,
		backgroundColor: '#f0f0f0',
	},
	scrollableContent: {
		flex: 1,
	},
	scrollableContentContainer: {
		padding: 24,
		paddingTop: 0,
		paddingBottom: 60,
		flexGrow: 1,
	},
	instructionText: {
		fontSize: 16,
		color: '#4c956c',
		textAlign: 'center',
		fontWeight: '600',
		padding: 12,
		backgroundColor: '#f0f9f4',
		borderRadius: 12,
		borderWidth: 1,
		borderColor: '#4c956c',
		marginTop: 20,
		marginBottom: 20,
	},
	cardSelectionContainer: {
		position: 'relative',
		marginBottom: 20,
		minHeight: 140,
	},
	cardScrollView: {
		height: 300,
		marginBottom: 20,
	},
	shrunkCardScrollView: {
		height: 140,
		marginBottom: 10,
	},
	scrollViewContent: {
		paddingHorizontal: 60,
		paddingRight: 80,
		alignItems: 'center',
	},
	arrowButton: {
		position: 'absolute',
		top: '50%',
		zIndex: 10,
		backgroundColor: '#ffffff',
		borderRadius: 25,
		width: 50,
		height: 50,
		justifyContent: 'center',
		alignItems: 'center',
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.1,
		shadowRadius: 8,
		elevation: 4,
		borderWidth: 1,
		borderColor: '#e2e8f0',
	},
	arrowLeft: {
		left: 10,
	},
	arrowRight: {
		right: 10,
	},
	cardContainer: {
		position: 'relative',
		margin: 8,
	},
	card: {
		width: STANDARD_CARD_WIDTH * 0.7,
		height: STANDARD_CARD_HEIGHT * 0.7,
		resizeMode: 'contain',
		borderRadius: 12,
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.1,
		shadowRadius: 8,
		elevation: 3,
	},
	selectedCard: {
		width: STANDARD_CARD_WIDTH * 0.7,
		height: STANDARD_CARD_HEIGHT * 0.7,
		resizeMode: 'contain',
		borderRadius: 12,
		borderWidth: 3,
		borderColor: '#4c956c',
		shadowColor: '#4c956c',
		shadowOffset: { width: 0, height: 6 },
		shadowOpacity: 0.3,
		shadowRadius: 12,
		elevation: 8,
	},
	selectedOverlay: {
		position: 'absolute',
		top: 10,
		right: 10,
		backgroundColor: '#ffffff',
		borderRadius: 16,
		padding: 4,
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 2 },
		shadowOpacity: 0.2,
		shadowRadius: 4,
		elevation: 3,
	},
	selectedCardPreview: {
		alignItems: 'center',
		marginTop: 10,
		marginBottom: 24,
		padding: 16,
		backgroundColor: '#f5f3e7',
		borderRadius: 16,
		borderWidth: 1,
		borderColor: '#d4c5a9',
	},
	previewHeader: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		marginBottom: 12,
	},
	previewTitle: {
		fontSize: 18,
		fontWeight: '600',
		color: '#2d3748',
	},
	clearButton: {
		padding: 4,
	},
	canvas: {
		width: STANDARD_CARD_WIDTH * 0.8,
		height: STANDARD_CARD_HEIGHT * 0.8,
		borderRadius: 12,
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.15,
		shadowRadius: 12,
	},
	formContainer: {
		width: '100%',
		marginBottom: 24,
	},
	inputContainer: {
		marginBottom: 20,
	},
	inputLabel: {
		fontSize: 16,
		fontWeight: '600',
		color: '#2d3748',
		marginBottom: 8,
	},
	input: {
		width: '100%',
		padding: 16,
		borderWidth: 2,
		borderColor: '#d4c5a9',
		borderRadius: 12,
		fontSize: 16,
		color: '#2d3748',
		backgroundColor: '#ffffff',
	},
	messageInput: {
		height: 100,
		textAlignVertical: 'top',
	},
	characterCount: {
		fontSize: 12,
		color: '#718096',
		textAlign: 'right',
		marginTop: 4,
	},
	buttonContainer: {
		width: '100%',
		alignItems: 'center',
	},
	primaryButton: {
		flexDirection: 'row',
		backgroundColor: '#4c956c',
		paddingVertical: 16,
		paddingHorizontal: 32,
		borderRadius: 12,
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 200,
		shadowColor: '#4c956c',
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.3,
		shadowRadius: 8,
		elevation: 4,
	},
	disabledButton: {
		backgroundColor: '#a0aec0',
		shadowColor: '#a0aec0',
	},
	buttonIcon: {
		marginRight: 8,
	},
	primaryButtonText: {
		color: '#ffffff',
		fontSize: 18,
		fontWeight: '700',
	},
	toast: {
		position: 'absolute',
		bottom: 20,
		left: 20,
		right: 20,
		backgroundColor: '#4c956c',
		padding: 16,
		borderRadius: 12,
		flexDirection: 'row',
		alignItems: 'center',
		shadowColor: '#000',
		shadowOffset: { width: 0, height: 4 },
		shadowOpacity: 0.3,
		shadowRadius: 8,
		elevation: 6,
	},
	toastIcon: {
		marginRight: 8,
	},
	toastText: {
		color: '#ffffff',
		fontSize: 16,
		fontWeight: '600',
		flex: 1,
	},
});

export default ECardSelectionModal;